import React from 'react'

const IntroContact = () => {
    return (
        <>
        <h4 style={{
            'fontSize':'0.9rem'}}
        >
         🏠 Székelyudvarhely, Városháza tér 5/1 
        </h4>
        <h4 style={{
            'fontSize':'0.9rem',
        }}
        >
          <a href="tel:0040751126339" style={{color:'inherit'}}> ☎️ (+4)0751-126-339</a> | <a href="tel:0040741093493"style={{color:'inherit'}}>(+4)0741-093-493</a>
        </h4>

        {/* <h4 style={{
            'fontSize':'0.9rem'}}
        >
         <a href="mailto:hr10gpo@gmail.com" style={{color:'inherit'}}> ✉️ hr10gpo@gmail.com </a>
        </h4> */}
        </>
    )
}

export default IntroContact
